module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/banner/intro-video-8794729a2bd6ae82662a68664d6431c6.jpg";